/* eslint-disable no-param-reassign */

import moment from 'moment';

/* eslint-disable import/prefer-default-export */
export class ComprasMockProvider {
  static activo = true as boolean;

  pojos = [
    {
      idTicket: '99990672071620634072',
      fecha: '10/05/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1620597600000,
    },
    {
      idTicket: '99990094671615973523',
      fecha: '17/03/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1294.0,
      ahorroTicket: 77.64,
      ingresoEroskiClub: 77.64,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1615935600000,
    },
    {
      idTicket: '99990093671615969299',
      fecha: '17/03/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 647.0,
      ahorroTicket: 38.82,
      ingresoEroskiClub: 38.82,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1615935600000,
    },
    {
      idTicket: '99990091671615968424',
      fecha: '17/03/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 647.0,
      ahorroTicket: 38.82,
      ingresoEroskiClub: 38.82,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1615935600000,
    },
    {
      idTicket: '99990058671615211980',
      fecha: '08/03/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.49,
      ahorroTicket: 0.15,
      ingresoEroskiClub: 0.15,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1615158000000,
    },
    {
      idTicket: '99990057671615211944',
      fecha: '08/03/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 0.96,
      ahorroTicket: 0.06,
      ingresoEroskiClub: 0.06,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1615158000000,
    },
    {
      idTicket: '99990056671615211916',
      fecha: '08/03/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.66,
      ahorroTicket: 0.1,
      ingresoEroskiClub: 0.1,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1615158000000,
    },
    {
      idTicket: '99990055671615211678',
      fecha: '08/03/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 0.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1615158000000,
    },
    {
      idTicket: '99990054671615211307',
      fecha: '08/03/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.53,
      ahorroTicket: 0.15,
      ingresoEroskiClub: 0.15,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1615158000000,
    },
    {
      idTicket: '99990053671615211253',
      fecha: '08/03/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 0.0,
      ahorroTicket: 0.06,
      ingresoEroskiClub: 0.06,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1615158000000,
    },
    {
      idTicket: '99990052671615211223',
      fecha: '08/03/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.66,
      ahorroTicket: 0.1,
      ingresoEroskiClub: 0.1,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1615158000000,
    },
    {
      idTicket: '99990050671615207134',
      fecha: '08/03/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.53,
      ahorroTicket: 0.09,
      ingresoEroskiClub: 0.09,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1615158000000,
    },
    {
      idTicket: '99990049671615206632',
      fecha: '08/03/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.66,
      ahorroTicket: 0.16,
      ingresoEroskiClub: 0.16,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1615158000000,
    },
    {
      idTicket: '99990135071613386526',
      fecha: '15/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1613343600000,
    },
    {
      idTicket: '99990134071613386217',
      fecha: '15/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1613343600000,
    },
    {
      idTicket: '99990133071613386016',
      fecha: '15/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1613343600000,
    },
    {
      idTicket: '99990131071613384353',
      fecha: '15/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1613343600000,
    },
    {
      idTicket: '99990130071613383674',
      fecha: '15/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1613343600000,
    },
    {
      idTicket: '99990129071613383565',
      fecha: '15/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 48.95,
      ahorroTicket: 2.94,
      ingresoEroskiClub: 2.94,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1613343600000,
    },
    {
      idTicket: '99990127071613382675',
      fecha: '15/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1613343600000,
    },
    {
      idTicket: '99990126071613381972',
      fecha: '15/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1613343600000,
    },
    {
      idTicket: '99990125071613381877',
      fecha: '15/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.5,
      ahorroTicket: 0.15,
      ingresoEroskiClub: 0.15,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1613343600000,
    },
    {
      idTicket: '99990124071613381767',
      fecha: '15/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1613343600000,
    },
    {
      idTicket: '99990030361613401038',
      fecha: '15/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1613343600000,
    },
    {
      idTicket: '99990026671613124555',
      fecha: '12/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.35,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1613084400000,
    },
    {
      idTicket: '99990025671613124056',
      fecha: '12/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1613084400000,
    },
    {
      idTicket: '99990024671613123838',
      fecha: '12/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.35,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1613084400000,
    },
    {
      idTicket: '99990023671613123064',
      fecha: '12/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.7,
      ahorroTicket: 0.16,
      ingresoEroskiClub: 0.16,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1613084400000,
    },
    {
      idTicket: '99990365701613029866',
      fecha: '11/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1612998000000,
    },
    {
      idTicket: '99990066071613031238',
      fecha: '11/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1612998000000,
    },
    {
      idTicket: '99990005361613033300',
      fecha: '11/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1612998000000,
    },
    {
      idTicket: '99990004361613032413',
      fecha: '11/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1612998000000,
    },
    {
      idTicket: '99990364701612973348',
      fecha: '10/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 48.95,
      ahorroTicket: 2.94,
      ingresoEroskiClub: 2.94,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1612911600000,
    },
    {
      idTicket: '99990363701612972564',
      fecha: '10/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 3.75,
      ahorroTicket: 0.23,
      ingresoEroskiClub: 0.23,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1612911600000,
    },
    {
      idTicket: '99990362701612972282',
      fecha: '10/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 48.95,
      ahorroTicket: 2.94,
      ingresoEroskiClub: 2.94,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1612911600000,
    },
    {
      idTicket: '99990361701612968764',
      fecha: '10/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 48.95,
      ahorroTicket: 2.94,
      ingresoEroskiClub: 2.94,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1612911600000,
    },
    {
      idTicket: '99990360701612967710',
      fecha: '10/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 50.2,
      ahorroTicket: 3.01,
      ingresoEroskiClub: 3.01,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1612911600000,
    },
    {
      idTicket: '99991125361612858036',
      fecha: '09/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.35,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1612825200000,
    },
    {
      idTicket: '99991118361612796861',
      fecha: '08/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.35,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1612738800000,
    },
    {
      idTicket: '99991116361612796658',
      fecha: '08/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.35,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1612738800000,
    },
    {
      idTicket: '99991115361612796627',
      fecha: '08/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 48.95,
      ahorroTicket: 2.94,
      ingresoEroskiClub: 2.94,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1612738800000,
    },
    {
      idTicket: '99991114361612796010',
      fecha: '08/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1612738800000,
    },
    {
      idTicket: '99991113361612795565',
      fecha: '08/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.35,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1612738800000,
    },
    {
      idTicket: '99990105301612776062',
      fecha: '08/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 50.2,
      ahorroTicket: 3.01,
      ingresoEroskiClub: 3.01,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1612738800000,
    },
    {
      idTicket: '99990340701612526314',
      fecha: '05/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 10.75,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1612479600000,
    },
    {
      idTicket: '99990011671612256415',
      fecha: '02/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.35,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1612220400000,
    },
    {
      idTicket: '99990010671612256187',
      fecha: '02/02/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.35,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1612220400000,
    },
    {
      idTicket: '99990464071611230026',
      fecha: '21/01/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.55,
      ahorroTicket: 0.09,
      ingresoEroskiClub: 0.09,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1611183600000,
    },
    {
      idTicket: '99990462071611228173',
      fecha: '21/01/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.55,
      ahorroTicket: 0.09,
      ingresoEroskiClub: 0.09,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1611183600000,
    },
    {
      idTicket: '99990461071611227992',
      fecha: '21/01/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.55,
      ahorroTicket: 0.09,
      ingresoEroskiClub: 0.09,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1611183600000,
    },
    {
      idTicket: '99990460071611227853',
      fecha: '21/01/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.55,
      ahorroTicket: 0.09,
      ingresoEroskiClub: 0.09,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1611183600000,
    },
    {
      idTicket: '99990137421611235065',
      fecha: '21/01/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.55,
      ahorroTicket: 0.09,
      ingresoEroskiClub: 0.09,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1611183600000,
    },
    {
      idTicket: '99990136421611234712',
      fecha: '21/01/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.55,
      ahorroTicket: 0.09,
      ingresoEroskiClub: 0.09,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1611183600000,
    },
    {
      idTicket: '99990135421611233843',
      fecha: '21/01/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 3.1,
      ahorroTicket: 0.19,
      ingresoEroskiClub: 0.19,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1611183600000,
    },
    {
      idTicket: '99990134421611232854',
      fecha: '21/01/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1611183600000,
    },
    {
      idTicket: '99990133421611232608',
      fecha: '21/01/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.55,
      ahorroTicket: 0.09,
      ingresoEroskiClub: 0.09,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1611183600000,
    },
    {
      idTicket: '99990132421611228404',
      fecha: '21/01/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.55,
      ahorroTicket: 0.09,
      ingresoEroskiClub: 0.09,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1611183600000,
    },
    {
      idTicket: '99990131421611228293',
      fecha: '21/01/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.55,
      ahorroTicket: 0.09,
      ingresoEroskiClub: 0.09,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1611183600000,
    },
    {
      idTicket: '99990644371611131483',
      fecha: '20/01/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.35,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1611097200000,
    },
    {
      idTicket: '99990559361611132696',
      fecha: '20/01/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.7,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1611097200000,
    },
    {
      idTicket: '99990556361611129952',
      fecha: '20/01/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.7,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1611097200000,
    },
    {
      idTicket: '99990126421611155948',
      fecha: '20/01/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1611097200000,
    },
    {
      idTicket: '99990122421611139365',
      fecha: '20/01/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1611097200000,
    },
    {
      idTicket: '99990120421611134621',
      fecha: '20/01/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.35,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1611097200000,
    },
    {
      idTicket: '99990119421611134240',
      fecha: '20/01/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.35,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1611097200000,
    },
    {
      idTicket: '99990118421611131743',
      fecha: '20/01/2021',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.35,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1611097200000,
    },
    {
      idTicket: '99990338361609164597',
      fecha: '28/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 200.0,
      ahorroTicket: 33.21,
      ingresoEroskiClub: 33.21,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1609110000000,
    },
    {
      idTicket: '99990337361609164457',
      fecha: '28/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 100.0,
      ahorroTicket: 23.36,
      ingresoEroskiClub: 23.36,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1609110000000,
    },
    {
      idTicket: '99990336361609164425',
      fecha: '28/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 100.0,
      ahorroTicket: 9.85,
      ingresoEroskiClub: 9.85,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1609110000000,
    },
    {
      idTicket: '99990335361609164280',
      fecha: '28/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 100.0,
      ahorroTicket: 6.0,
      ingresoEroskiClub: 6.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1609110000000,
    },
    {
      idTicket: '99990330361609161466',
      fecha: '28/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 100.0,
      ahorroTicket: 6.0,
      ingresoEroskiClub: 6.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1609110000000,
    },
    {
      idTicket: '99990329361609159684',
      fecha: '28/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 100.0,
      ahorroTicket: 6.0,
      ingresoEroskiClub: 6.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1609110000000,
    },
    {
      idTicket: '99990241071608636714',
      fecha: '22/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 10.9,
      ahorroTicket: 0.65,
      ingresoEroskiClub: 0.65,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608591600000,
    },
    {
      idTicket: '99990240071608636657',
      fecha: '22/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 5.0,
      ahorroTicket: 0.3,
      ingresoEroskiClub: 0.3,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608591600000,
    },
    {
      idTicket: '99990239071608636580',
      fecha: '22/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 4.25,
      ahorroTicket: 0.26,
      ingresoEroskiClub: 0.26,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608591600000,
    },
    {
      idTicket: '99990238071608635844',
      fecha: '22/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 4.77,
      ahorroTicket: 0.29,
      ingresoEroskiClub: 0.29,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608591600000,
    },
    {
      idTicket: '99990627371608541511',
      fecha: '21/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.35,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608505200000,
    },
    {
      idTicket: '99990626371608541358',
      fecha: '21/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608505200000,
    },
    {
      idTicket: '99990625371608541127',
      fecha: '21/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.35,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608505200000,
    },
    {
      idTicket: '99990624371608540501',
      fecha: '21/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.35,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608505200000,
    },
    {
      idTicket: '99990236071608565899',
      fecha: '21/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608505200000,
    },
    {
      idTicket: '99990231071608563960',
      fecha: '21/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 555.0,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608505200000,
    },
    {
      idTicket: '99990230071608560426',
      fecha: '21/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608505200000,
    },
    {
      idTicket: '99990229071608555252',
      fecha: '21/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608505200000,
    },
    {
      idTicket: '99990228071608555199',
      fecha: '21/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608505200000,
    },
    {
      idTicket: '99990227071608554947',
      fecha: '21/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608505200000,
    },
    {
      idTicket: '99990226071608554790',
      fecha: '21/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608505200000,
    },
    {
      idTicket: '99990225071608554694',
      fecha: '21/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608505200000,
    },
    {
      idTicket: '99990224071608554375',
      fecha: '21/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608505200000,
    },
    {
      idTicket: '99990223071608554313',
      fecha: '21/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608505200000,
    },
    {
      idTicket: '99990216071608547381',
      fecha: '21/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 4.05,
      ahorroTicket: 0.24,
      ingresoEroskiClub: 0.24,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608505200000,
    },
    {
      idTicket: '99990212071608547200',
      fecha: '21/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 21.0,
      ahorroTicket: 1.02,
      ingresoEroskiClub: 1.02,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608505200000,
    },
    {
      idTicket: '99990209071608547007',
      fecha: '21/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 145.92,
      ahorroTicket: 9.22,
      ingresoEroskiClub: 9.22,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608505200000,
    },
    {
      idTicket: '99990208071608546914',
      fecha: '21/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 5.0,
      ahorroTicket: 0.3,
      ingresoEroskiClub: 0.3,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608505200000,
    },
    {
      idTicket: '99990206071608546763',
      fecha: '21/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 50.3,
      ahorroTicket: 3.02,
      ingresoEroskiClub: 3.02,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608505200000,
    },
    {
      idTicket: '99990204071608546585',
      fecha: '21/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 19.0,
      ahorroTicket: 1.2,
      ingresoEroskiClub: 1.2,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608505200000,
    },
    {
      idTicket: '99990199071608546314',
      fecha: '21/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 27.35,
      ahorroTicket: 1.64,
      ingresoEroskiClub: 1.64,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608505200000,
    },
    {
      idTicket: '99990195071608544506',
      fecha: '21/12/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 50.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1608505200000,
    },
    {
      idTicket: '99990130321603377703',
      fecha: '22/10/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 32.84,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1603317600000,
    },
    {
      idTicket: '99990129321603372224',
      fecha: '22/10/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 35.84,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1603317600000,
    },
    {
      idTicket: '99990128321603371744',
      fecha: '22/10/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 35.84,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1603317600000,
    },
    {
      idTicket: '99990127321603371080',
      fecha: '22/10/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 35.84,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1603317600000,
    },
    {
      idTicket: '99990126321603370849',
      fecha: '22/10/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 32.84,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1603317600000,
    },
    {
      idTicket: '99990125321603370531',
      fecha: '22/10/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 32.84,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1603317600000,
    },
    {
      idTicket: '99990124321603366441',
      fecha: '22/10/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 5.84,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1603317600000,
    },
    {
      idTicket: '99990528371601467016',
      fecha: '30/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1601416800000,
    },
    {
      idTicket: '99990527371601466828',
      fecha: '30/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1601416800000,
    },
    {
      idTicket: '99990526371601463175',
      fecha: '30/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1601416800000,
    },
    {
      idTicket: '99990525371601462257',
      fecha: '30/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1601416800000,
    },
    {
      idTicket: '99990524371601460861',
      fecha: '30/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 3.75,
      ahorroTicket: 0.23,
      ingresoEroskiClub: 0.23,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1601416800000,
    },
    {
      idTicket: '99990523371601460279',
      fecha: '30/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1601416800000,
    },
    {
      idTicket: '99990522371601459448',
      fecha: '30/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1601416800000,
    },
    {
      idTicket: '99990521371601457610',
      fecha: '30/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.35,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1601416800000,
    },
    {
      idTicket: '99990520371601455019',
      fecha: '30/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 7.5,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1601416800000,
    },
    {
      idTicket: '99991774361600933068',
      fecha: '24/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.7,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1600898400000,
    },
    {
      idTicket: '99991773361600932879',
      fecha: '24/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.7,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1600898400000,
    },
    {
      idTicket: '99990516371600938283',
      fecha: '24/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.35,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1600898400000,
    },
    {
      idTicket: '99990515371600937431',
      fecha: '24/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.35,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1600898400000,
    },
    {
      idTicket: '99990514371600934841',
      fecha: '24/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.35,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1600898400000,
    },
    {
      idTicket: '02381775361600933944',
      fecha: '24/09/2020',
      concepto: 'E. CITY ORIXE',
      importe: 1.7,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1600898400000,
    },
    {
      idTicket: '99991770361600845926',
      fecha: '23/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.7,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1600812000000,
    },
    {
      idTicket: '99991769361600845450',
      fecha: '23/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.7,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1600812000000,
    },
    {
      idTicket: '99991768361600845117',
      fecha: '23/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.7,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1600812000000,
    },
    {
      idTicket: '99991767361600843546',
      fecha: '23/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.7,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1600812000000,
    },
    {
      idTicket: '99991766361600842531',
      fecha: '23/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.7,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1600812000000,
    },
    {
      idTicket: '99991765361600841588',
      fecha: '23/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.7,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1600812000000,
    },
    {
      idTicket: '99991763361600780878',
      fecha: '22/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 3.25,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1600725600000,
    },
    {
      idTicket: '99991762361600780416',
      fecha: '22/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 3.25,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1600725600000,
    },
    {
      idTicket: '99991761361600780352',
      fecha: '22/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 3.25,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1600725600000,
    },
    {
      idTicket: '99991760361600779225',
      fecha: '22/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 3.25,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1600725600000,
    },
    {
      idTicket: '99991759361600779085',
      fecha: '22/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 3.25,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1600725600000,
    },
    {
      idTicket: '99991757361600775798',
      fecha: '22/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.99,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1600725600000,
    },
    {
      idTicket: '99991756361600775410',
      fecha: '22/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.7,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1600725600000,
    },
    {
      idTicket: '99991755361600775389',
      fecha: '22/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.7,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1600725600000,
    },
    {
      idTicket: '99991754361600775270',
      fecha: '22/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.55,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1600725600000,
    },
    {
      idTicket: '99991753361600775237',
      fecha: '22/09/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.55,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1600725600000,
    },
    {
      idTicket: '99991342361594979707',
      fecha: '17/07/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 5.07,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1594936800000,
    },
    {
      idTicket: '99991341361594977345',
      fecha: '17/07/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.69,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1594936800000,
    },
    {
      idTicket: '99991340361594970529',
      fecha: '17/07/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 3.18,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1594936800000,
    },
    {
      idTicket: '99991311361594283241',
      fecha: '09/07/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 31.41,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1594245600000,
    },
    {
      idTicket: '99991310361594281375',
      fecha: '09/07/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 47.77,
      ahorroTicket: 3.0,
      ingresoEroskiClub: 3.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1594245600000,
    },
    {
      idTicket: '99991309361594281316',
      fecha: '09/07/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 48.66,
      ahorroTicket: 29.28,
      ingresoEroskiClub: 29.28,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1594245600000,
    },
    {
      idTicket: '99991308361594281190',
      fecha: '09/07/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 51.33,
      ahorroTicket: 29.55,
      ingresoEroskiClub: 29.55,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1594245600000,
    },
    {
      idTicket: '99991305361594278694',
      fecha: '09/07/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 19.56,
      ahorroTicket: 0.18,
      ingresoEroskiClub: 0.18,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1594245600000,
    },
    {
      idTicket: '99991304361594278587',
      fecha: '09/07/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 49.55,
      ahorroTicket: 29.37,
      ingresoEroskiClub: 29.37,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1594245600000,
    },
    {
      idTicket: '99991303361594278469',
      fecha: '09/07/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.78,
      ahorroTicket: 0.18,
      ingresoEroskiClub: 0.18,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1594245600000,
    },
    {
      idTicket: '99991301361594278321',
      fecha: '09/07/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 100.58,
      ahorroTicket: 29.37,
      ingresoEroskiClub: 29.37,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1594245600000,
    },
    {
      idTicket: '99991300361594277837',
      fecha: '09/07/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 150.83,
      ahorroTicket: 31.13,
      ingresoEroskiClub: 31.13,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1594245600000,
    },
    {
      idTicket: '99991297361594277319',
      fecha: '09/07/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 0.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1594245600000,
    },
    {
      idTicket: '99990212121590134261',
      fecha: '22/05/2020',
      concepto: 'CENTRO PRUEBAS GASO',
      importe: 3.53,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1590098400000,
    },
    {
      idTicket: '99990211121590133619',
      fecha: '22/05/2020',
      concepto: 'CENTRO PRUEBAS GASO',
      importe: 3.53,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1590098400000,
    },
    {
      idTicket: '99990210121590133434',
      fecha: '22/05/2020',
      concepto: 'CENTRO PRUEBAS GASO',
      importe: 1.95,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1590098400000,
    },
    {
      idTicket: '57510901041590140536',
      fecha: '22/05/2020',
      concepto: 'E.S. CC BALLONTI',
      importe: 99.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1590098400000,
    },
    {
      idTicket: '57510900041590140233',
      fecha: '22/05/2020',
      concepto: 'E.S. CC BALLONTI',
      importe: 79.2,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1590098400000,
    },
    {
      idTicket: '57510899041590132334',
      fecha: '22/05/2020',
      concepto: 'E.S. CC BALLONTI',
      importe: 19.8,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1590098400000,
    },
    {
      idTicket: '99990423071589637752',
      fecha: '16/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 14.94,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589580000000,
    },
    {
      idTicket: '99990418071589531446',
      fecha: '15/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 3.82,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589493600000,
    },
    {
      idTicket: '99990401071589467900',
      fecha: '14/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990396071589466015',
      fecha: '14/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990389071589461618',
      fecha: '14/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990386071589452669',
      fecha: '14/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 38.89,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990383071589449766',
      fecha: '14/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990382071589449690',
      fecha: '14/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 2.5,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990381071589448090',
      fecha: '14/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990380071589444930',
      fecha: '14/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990379071589444811',
      fecha: '14/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990378071589444651',
      fecha: '14/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990377071589444557',
      fecha: '14/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990376071589444440',
      fecha: '14/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990375071589444329',
      fecha: '14/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990374071589444208',
      fecha: '14/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990373071589444116',
      fecha: '14/05/2020',
      concepto: 'LABORATORIO AMAIA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990372071589443902',
      fecha: '14/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990371071589443746',
      fecha: '14/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990370071589443599',
      fecha: '14/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990365071589408332',
      fecha: '14/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990364071589408177',
      fecha: '14/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990363071589408048',
      fecha: '14/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990362071589407959',
      fecha: '14/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990361071589407880',
      fecha: '14/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990360071589407764',
      fecha: '14/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990359071589407632',
      fecha: '14/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990358071589407533',
      fecha: '14/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990357071589407374',
      fecha: '14/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990356071589407201',
      fecha: '14/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589407200000,
    },
    {
      idTicket: '99990355071589407141',
      fecha: '13/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589320800000,
    },
    {
      idTicket: '99990354071589407000',
      fecha: '13/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589320800000,
    },
    {
      idTicket: '99990353071589406864',
      fecha: '13/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589320800000,
    },
    {
      idTicket: '99990352071589406788',
      fecha: '13/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589320800000,
    },
    {
      idTicket: '99990351071589406374',
      fecha: '13/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589320800000,
    },
    {
      idTicket: '99990350071589406251',
      fecha: '13/05/2020',
      concepto: 'CENTER GIBRALTAR',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589320800000,
    },
    {
      idTicket: '99990349071589405492',
      fecha: '13/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589320800000,
    },
    {
      idTicket: '99990348071589405400',
      fecha: '13/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589320800000,
    },
    {
      idTicket: '99990347071589405215',
      fecha: '13/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589320800000,
    },
    {
      idTicket: '99990346071589405139',
      fecha: '13/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589320800000,
    },
    {
      idTicket: '03991574881589302507',
      fecha: '12/05/2020',
      concepto: 'LABORATORIO AMAIA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589234400000,
    },
    {
      idTicket: '03990338881589303314',
      fecha: '12/05/2020',
      concepto: 'LABORATORIO AMAIA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589234400000,
    },
    {
      idTicket: '99990304071589211166',
      fecha: '11/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589148000000,
    },
    {
      idTicket: '99990301071589210663',
      fecha: '11/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589148000000,
    },
    {
      idTicket: '99990300071589210432',
      fecha: '11/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589148000000,
    },
    {
      idTicket: '03991563881589208736',
      fecha: '11/05/2020',
      concepto: 'LABORATORIO AMAIA',
      importe: 2.46,
      ahorroTicket: 0.86,
      ingresoEroskiClub: 0.86,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589148000000,
    },
    {
      idTicket: '03991562881589208318',
      fecha: '11/05/2020',
      concepto: 'LABORATORIO AMAIA',
      importe: 0.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589148000000,
    },
    {
      idTicket: '03991561881589208269',
      fecha: '11/05/2020',
      concepto: 'LABORATORIO AMAIA',
      importe: 0.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589148000000,
    },
    {
      idTicket: '03991560881589207690',
      fecha: '11/05/2020',
      concepto: 'LABORATORIO AMAIA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589148000000,
    },
    {
      idTicket: '03991559881589207568',
      fecha: '11/05/2020',
      concepto: 'LABORATORIO AMAIA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1589148000000,
    },
    {
      idTicket: '99990282071588937762',
      fecha: '08/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.46,
      ahorroTicket: 0.86,
      ingresoEroskiClub: 0.86,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1588888800000,
    },
    {
      idTicket: '99990281071588937467',
      fecha: '08/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1588888800000,
    },
    {
      idTicket: '99990280071588937349',
      fecha: '08/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 4.14,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1588888800000,
    },
    {
      idTicket: '99990279071588937320',
      fecha: '08/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1588888800000,
    },
    {
      idTicket: '99990277071588936968',
      fecha: '08/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 2.46,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1588888800000,
    },
    {
      idTicket: '99990276071588936616',
      fecha: '08/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 0.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1588888800000,
    },
    {
      idTicket: '99990275071588936506',
      fecha: '08/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.53,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1588888800000,
    },
    {
      idTicket: '99990274071588925608',
      fecha: '08/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 10.54,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1588888800000,
    },
    {
      idTicket: '99990273071588924415',
      fecha: '08/05/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 4.74,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1588888800000,
    },
    {
      idTicket: '99990096071587657995',
      fecha: '23/04/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 0.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1587592800000,
    },
    {
      idTicket: '99990087071587642795',
      fecha: '23/04/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 0.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1587592800000,
    },
    {
      idTicket: '99990083071587568772',
      fecha: '22/04/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 0.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1587506400000,
    },
    {
      idTicket: '99990082071587567596',
      fecha: '22/04/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 0.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1587506400000,
    },
    {
      idTicket: '99990081071587567419',
      fecha: '22/04/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 0.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1587506400000,
    },
    {
      idTicket: '99990080071587564506',
      fecha: '22/04/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 100.5,
      ahorroTicket: 6.03,
      ingresoEroskiClub: 6.03,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1587506400000,
    },
    {
      idTicket: '99990078071587563574',
      fecha: '22/04/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 100.5,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1587506400000,
    },
    {
      idTicket: '99990077071587563181',
      fecha: '22/04/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 13.5,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1587506400000,
    },
    {
      idTicket: '99990072071587562363',
      fecha: '22/04/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 195.8,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1587506400000,
    },
    {
      idTicket: '99990071071587561971',
      fecha: '22/04/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 195.8,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1587506400000,
    },
    {
      idTicket: '99990068071587561182',
      fecha: '22/04/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.35,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1587506400000,
    },
    {
      idTicket: '99990067071587561147',
      fecha: '22/04/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.35,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1587506400000,
    },
    {
      idTicket: '99990025141587484730',
      fecha: '21/04/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 0.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1587420000000,
    },
    {
      idTicket: '99990024141587481831',
      fecha: '21/04/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.35,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1587420000000,
    },
    {
      idTicket: '99990023141587478645',
      fecha: '21/04/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.72,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1587420000000,
    },
    {
      idTicket: '99990061071587397306',
      fecha: '20/04/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 0.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1587333600000,
    },
    {
      idTicket: '99990060071587391645',
      fecha: '20/04/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 0.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1587333600000,
    },
    {
      idTicket: '99990012071585925608',
      fecha: '03/04/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 0.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1585864800000,
    },
    {
      idTicket: '99990011071585925360',
      fecha: '03/04/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 0.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1585864800000,
    },
    {
      idTicket: '99990009071585924738',
      fecha: '03/04/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.35,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1585864800000,
    },
    {
      idTicket: '99990603361584691992',
      fecha: '20/03/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 25.51,
      ahorroTicket: 5.07,
      ingresoEroskiClub: 5.07,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1584658800000,
    },
    {
      idTicket: '99990596361584524724',
      fecha: '18/03/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 8.31,
      ahorroTicket: 1.46,
      ingresoEroskiClub: 1.46,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1584486000000,
    },
    {
      idTicket: '99990595361584523690',
      fecha: '18/03/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 25.51,
      ahorroTicket: 5.07,
      ingresoEroskiClub: 5.07,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1584486000000,
    },
    {
      idTicket: '99990498361583488928',
      fecha: '06/03/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1583449200000,
    },
    {
      idTicket: '99990495361583488618',
      fecha: '06/03/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1583449200000,
    },
    {
      idTicket: '99990494361583488418',
      fecha: '06/03/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1583449200000,
    },
    {
      idTicket: '99990493361583488207',
      fecha: '06/03/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1583449200000,
    },
    {
      idTicket: '99990492361583487943',
      fecha: '06/03/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1583449200000,
    },
    {
      idTicket: '99990491361583487361',
      fecha: '06/03/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1583449200000,
    },
    {
      idTicket: '99990487361583421433',
      fecha: '05/03/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1583362800000,
    },
    {
      idTicket: '99990486361583421074',
      fecha: '05/03/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1583362800000,
    },
    {
      idTicket: '99990485361583420745',
      fecha: '05/03/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1583362800000,
    },
    {
      idTicket: '99990481361583420007',
      fecha: '05/03/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1583362800000,
    },
    {
      idTicket: '99990480361583419983',
      fecha: '05/03/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 0.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1583362800000,
    },
    {
      idTicket: '99990479361583419586',
      fecha: '05/03/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 0.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1583362800000,
    },
    {
      idTicket: '99990477361583418993',
      fecha: '05/03/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 0.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1583362800000,
    },
    {
      idTicket: '99990344401581608434',
      fecha: '13/02/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1581548400000,
    },
    {
      idTicket: '99990340401581497181',
      fecha: '12/02/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 23.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1581462000000,
    },
    {
      idTicket: '99990476321580288992',
      fecha: '29/01/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.0,
      ahorroTicket: 0.06,
      ingresoEroskiClub: 0.06,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1580252400000,
    },
    {
      idTicket: '99990474321580230327',
      fecha: '28/01/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 3.1,
      ahorroTicket: 0.19,
      ingresoEroskiClub: 0.19,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1580166000000,
    },
    {
      idTicket: '99990473321580220889',
      fecha: '28/01/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 1.25,
      ahorroTicket: 0.08,
      ingresoEroskiClub: 0.08,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1580166000000,
    },
    {
      idTicket: '99990227361579012129',
      fecha: '14/01/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 10.0,
      ahorroTicket: 2.1,
      ingresoEroskiClub: 2.1,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1578956400000,
    },
    {
      idTicket: '99990226361579012083',
      fecha: '14/01/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 10.0,
      ahorroTicket: 0.6,
      ingresoEroskiClub: 0.6,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1578956400000,
    },
    {
      idTicket: '99990224361578924394',
      fecha: '13/01/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 188.12,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1578870000000,
    },
    {
      idTicket: '99990223361578923933',
      fecha: '13/01/2020',
      concepto: 'MERCA ASTRABUDUA',
      importe: 188.12,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1578870000000,
    },
    {
      idTicket: '99990051361577448600',
      fecha: '27/12/2019',
      concepto: 'MERCA ASTRABUDUA',
      importe: 10.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1577401200000,
    },
    {
      idTicket: '99990345321576835519',
      fecha: '20/12/2019',
      concepto: 'MERCA ASTRABUDUA',
      importe: 0.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1576796400000,
    },
    {
      idTicket: '99990344321576835480',
      fecha: '20/12/2019',
      concepto: 'MERCA ASTRABUDUA',
      importe: 0.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1576796400000,
    },
    {
      idTicket: '99990343321576835133',
      fecha: '20/12/2019',
      concepto: 'MERCA ASTRABUDUA',
      importe: 0.0,
      ahorroTicket: 0.0,
      ingresoEroskiClub: 0.0,
      ingresoEroskiClubOro: 0.0,
      otrosDescuentos: 0.0,
      objetoDate: 1576796400000,
    },
  ];

  getComprasResponse = () => {
    const data = {
      error: false,
      pojos: this.pojos,
      pageNumber: null,
      totalElements: 263,
    };
    return data;
  };

  getComprasResponseByDates = (from: string, to: string) => {
    const filteredPojos = this.pojos.filter((pojo) =>
      this.filter(pojo, from, to),
    );
    const data = {
      error: false,
      pojos: filteredPojos,
      pageNumber: null,
      totalElements: filteredPojos.length,
    };
    return data;
  };

  isActivo = () => {
    return ComprasMockProvider.activo;
  };

  setActivo = () => {
    ComprasMockProvider.activo = !ComprasMockProvider.activo;
  };

  private filter = (pojo: any, from: string, to: string) => {
    const fecha = moment(pojo.fecha, 'DD/MM/YYYY');
    const toDate = moment(to, 'DD/MM/YYYY');
    const fromDate = moment(from, 'DD/MM/YYYY');

    if (
      (fecha.isAfter(fromDate) || fecha.isSame(fromDate)) &&
      (fecha.isBefore(toDate) || fecha.isSame(toDate))
    ) {
      return pojo;
    }
    return null;
  };
}
